export default __webpack_public_path__ + "static/purchaseSword-6baa026ec2d0f8cf25dff8824a80c927.png";